import { Button } from '@material-ui/core';
import { DataGrid } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react'
import useStyles from "../PartyStockLedger/style";
import { COMPANY_CODE, GET_ALL_CATEGORIES, GET_VIEW_ACCOUNT_REPORT } from '../../../constant';
import axios from 'axios';

function AccountStatus() {
  const classes = useStyles();

  var today = new Date().toISOString().slice(0, 10); // get today's date in ISO format (yyyy-MM-dd)
  var toda = new Date();
  var tomorrow = new Date(toda);
  tomorrow.setDate(tomorrow.getDate() + 1);
  var nextday = tomorrow.toISOString().slice(0, 10);
  const [fromdate, setfromdate] = useState(today)
  const [todate, settodate] = useState(nextday)


  const [acconutstatus, setacconutstatus] = useState([]);
  const [companyColor, setcompanyColor] = useState("")
  const [AllCategories,SetAllCategories] =useState([])
  const [selectedValue, setSelectedValue] = useState('');
  const [isChecked, setIsChecked] = useState(false);


  useEffect(() => {
    setcompanyColor(localStorage.getItem('cmpnyType'))
    //API FOR GET ALL CATEGORIES
    axios.post(GET_ALL_CATEGORIES, {
      "CompanyNumber": COMPANY_CODE,
    }
    ).then((response) => {
      console.log(response)
      if (response.data.IsSuccess === true) {
        SetAllCategories(response.data.Data);
      }
      else {
        // var emptList=[];
        SetAllCategories([]);
      }
    })

  }, [])

  const acconutstatusclm = [
    { field: 'AccountName', headerName: 'Account Name', width: 150 },
    { field: 'Category', headerName: 'Category', width: 150 },
    {
      field: "CompanyNumber",
      headerName: "Company Number",
      width: 180,
      disableClickEventBubbling: true,
      renderCell: (params) => {

        return (
          params.row.CompanyNumber === null ? COMPANY_CODE : params.row.CompanyNumber

        );
      }
    },
    { field: 'CreatedDate', headerName: 'Created Date', width: 150 },
    { field: 'Credit', headerName: 'Credit', width: 150 },
    { field: 'Currency', headerName: 'Currency', width: 150 },
    { field: 'Dabit', headerName: 'Debit', width: 150 },
    { field: 'FormDate', headerName: 'Form Date', width: 150 },
    { field: 'Mcode', headerName: 'Mcode', width: 150 },
    { field: 'ToDate', headerName: 'To Date', width: 150 },
    { field: 'chkLocalCurrency', headerName: 'Local Currency', width: 150 },
    { field: 'classification', headerName: 'Classification', width: 150 },
    { field: 'closingCredit', headerName: 'Closing Credit', width: 150 },
    { field: 'closingDabit', headerName: 'Closing Debit', width: 150 },
    { field: 'openingCredit', headerName: 'Opening Credit', width: 150 },
    { field: 'openingDabit', headerName: 'Opening Debit', width: 150 },
  ]


  const loadData = () => {
    axios.post(GET_VIEW_ACCOUNT_REPORT, {
      "CompanyNumber": "10", "FormDate": fromdate, "ToDate": todate, "chkLocalCurrency": isChecked, "Category": selectedValue
    }
    ).then((response) => {
      console.log(response)
      if (response.data.IsSuccess === true) {
        setacconutstatus(response.data.Data);
      }
      else {
        // var emptList=[];
        setacconutstatus([]);
      }
    })
  }


  return (
    <div className="balacepoupformmain " >
      <div className="stockStatusform" style={{ color: '#0b5aa4', paddingTop: '10px', width: '100%', display: 'flex', justifyContent: 'space-between' }}>

        <div className='stockStatusform main'>
          <div>
            <span >Warehouse: </span>
            <select  className='stockwarehouse' style={{  }} onChange={(e) => setSelectedValue(e.target.value)}>
            <option value="">MAIN</option>
              {
                AllCategories.map((item,i)=>(
                   <option value={item.Type}>{item.Category}</option>
                ))
              }
            </select>
                   
            <span >&nbsp;&nbsp;Category: </span>
            <select  className='stockwarehouse' style={{}} onChange={(e) => setSelectedValue(e.target.value)}>
            <option value="">ALL CATEGORIES</option>
              {
                AllCategories.map((item,i)=>(
                   <option value={item.Type}>{item.Category}</option>
                ))
              }
            </select>
              
          </div>
          <div >
            <p className='stockyear'  style={{width:'390px'}}>Financial Year : <span>
              <input type="date"  value={fromdate} style={{marginRight:'10px'}} onChange={(e) => setfromdate(e.target.value)} />
              <input type="date" value={todate} onChange={(e) => settodate(e.target.value)} />
            </span> </p>

          </div>
          {/* <div>
            <div className='accontstatus_checkbox'>
            <input type="checkbox" style={{ width:'20px', height:'20px', marginTop:'3px' }} id="one" name="sales_officer" checked={isChecked} onChange={(e) => setIsChecked(e.target.checked)}/><span className='accountStatusform_secondgrid_span' style={{ fontSize: '12px', marginLeft:"5px", marginBottom:'4px' }}>Report in Local Currency</span>
          </div></div> */}
          <div className="d-block stockstatusbtns" style={{ justifyContent: 'space-between', width: '190px', marginTop:'-5px' }}>
            <button type="button"  style={{ paddingLeft:'15px', paddingRight:'15px'}}className={` stockStatusformbtn ${classes[companyColor?.split(',')[0]]}  my-1`} onClick={loadData}>LOAD DATA</button>

          </div>
        </div>
      </div>


      <div className='table animatingBottom whiteheader' style={{ height: "500px", width: "100%", background: '#fff' }}>
        <DataGrid
          rows={acconutstatus}
          columns={acconutstatusclm}
          pageSize={7}
          className={classes[companyColor?.split(',')[0]]}
          // onCellClick={handlePendingRfqsCellClick}
          getRowId={(row) => row.Mcode}
          // checkboxSelection

          {...acconutstatus}
        />
      </div>
      <div className='' style={{float:'right'}} >
                <div className='col ' >
                 <div className='stockstatusbutton' style={{float:'left', marginBottom:"10px"}} >  
                 <Button variant='contained' className={classes[companyColor?.split(',')[0]]}>Search </Button>&nbsp;
                <Button variant="contained" className={classes[companyColor?.split(',')[0]]}  >Excel</Button>&nbsp;</div> 
                <Button variant="contained" className={classes[companyColor?.split(',')[0]]}  >Cancel</Button>&nbsp;
                <Button variant="contained" className={classes[companyColor?.split(',')[0]]}  >Exit</Button>

                </div>
            </div>

    </div>

  );
}
export default AccountStatus;